import { FirefoxSVG, ChromeSVG, RightArrowSVG, EdgeSVG, OperaGXSVG } from "../../../assets/iconSvg";
import ButtonIcon from "../../../components/container/button";
import Carousel from "../../../components/container/carousel";
import HeadLayout from "../../../components/layout/RootLayout";
import { isEdge, isFirefox, isOperaGX } from "../../../utils/browerType";
import './ParqueInvierno.css';

const pageChildren = () => {
  const images = ["/parque-invierno/info.png", "/parque-invierno/municipio.png"];

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row gap-8 md:gap-12 mb-16">
        <div className="w-full md:w-1/2 flex flex-col">
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">Parque Invierno</h1>
            <p className="text-xl text-gray-700 dark:text-gray-300 mb-6">Aplicación realizada para el Municipio de Hurlingham</p>

            <div className="flex flex-wrap gap-3 mb-8">
              <a href="https://appetize.io/app/b_k2bhi7nqqmzvkz3pkk64sw5yre" className="inline-block">
                <ButtonIcon color={"#0071c2"} title="Live Demo"> 
                  <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l5 5l-5 5m5-5H4" />
                  </svg>
                </ButtonIcon>
              </a>
              
              <a href="/projects/parque-invierno/downloads" className="inline-block">
                <ButtonIcon color={"#0071c2"} title="Descargar APK"> 
                  <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m17 13l-5 5m0 0l-5-5m5 5V6" />
                  </svg>
                </ButtonIcon>
              </a>
            </div>
        </div>
          
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Características destacadas</h2>
            <ul className="space-y-3 text-gray-700 dark:text-gray-300">
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Desarrollado en React Native</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Más de +18.000 dispositivos compatibles con la aplicación</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Interfaz intuitiva y fácil de usar</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Diseño responsivo adaptado a diferentes tamaños de pantalla</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                <span>Óptimo rendimiento en dispositivos de gama baja a alta</span>
              </li>
            </ul>
          </div>
          
          <div className="bg-gray-50 dark:bg-gray-800/40 rounded-xl p-6">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Sobre el proyecto</h2>
            <p className="text-gray-600 dark:text-gray-400">
              Parque Invierno es una aplicación móvil desarrollada para el Municipio de Hurlingham 
              que permite a los ciudadanos acceder a información relevante sobre actividades, 
              servicios y novedades municipales. La aplicación facilita la comunicación entre 
              el municipio y sus habitantes, mejorando la experiencia ciudadana.
            </p>
          </div>
        </div>
        
        <div className="w-full md:w-1/2 flex items-center justify-center">
          <div className="w-full max-w-sm overflow-hidden rounded-xl shadow-lg bg-white dark:bg-gray-800">
            <Carousel images={images} />
          </div>
</div>
      </div>
      
      {/* Additional Information Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Plataforma</h3>
          <div className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 dark:text-blue-400 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
              <line x1="12" y1="18" x2="12" y2="18"></line>
            </svg>
            <span className="text-gray-700 dark:text-gray-300">Android</span>
          </div>
        </div>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Tecnologías</h3>
          <p className="text-gray-700 dark:text-gray-300">React Native</p>
          <p className="text-gray-700 dark:text-gray-300">JavaScript</p>
          <p className="text-gray-700 dark:text-gray-300">APIs RESTful</p>
        </div>
        
        <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-xl">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Cliente</h3>
          <p className="text-gray-700 dark:text-gray-300">Municipio de Hurlingham</p>
          <p className="text-gray-700 dark:text-gray-300">Buenos Aires, Argentina</p>
          <p className="text-gray-700 dark:text-gray-300">2022</p>
        </div>
      </div>
    </div>
  );
};

function ParqueInvierno() {
  return (
    <HeadLayout 
      title="Parque Invierno | Leonardo Capone" 
      description="Aplicación móvil desarrollada para el Municipio de Hurlingham que facilita la comunicación entre el gobierno local y sus ciudadanos."
      keywords="Parque Invierno, React Native, aplicación móvil, Hurlingham, municipio, desarrollo de apps, Leonardo Capone"
    >
      {pageChildren()}
    </HeadLayout>
  );
}

export default ParqueInvierno;

